import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeDayKey, sanitizeMonthKey } from "@/lib/period-search";
import { appRoute } from "./route";

const CalendarPage = lazy(async () => {
  const m = await import("@/features/reports/components/calendar-page");
  return { default: m.CalendarPage };
});

function CalendarPageWrapper() {
  return (
    <Suspense fallback={null}>
      <CalendarPage />
    </Suspense>
  );
}

interface CalendarSearch {
  /** Displayed month (`YYYY-MM`); absent = current month (default omitted). */
  month?: string;
  /** Selected day (`YYYY-MM-DD`); its detail is a shareable detail state. */
  day?: string;
}

/** validateSearch: the displayed month and selected day live in the URL. */
function sanitizeCalendarSearch(search: Record<string, unknown>): CalendarSearch {
  return {
    month: sanitizeMonthKey(search.month),
    day: sanitizeDayKey(search.day),
  };
}

export const calendarRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/calendar",
  validateSearch: sanitizeCalendarSearch,
  component: CalendarPageWrapper,
});
